import { AccountsState } from "./types";

export const ACCOUNTS_DEFAULT_STATE: AccountsState = {
  accountData: {},
  transactions: {},
  splits: {},
  ready: false
};
